<template>
  <section
    class="type-sandbox"
    data-aos="zoom-in"
  >
    <div
      class="type-sandbox__wrapper"
      :class="isTextWhite && 'orange-bg white-border'"
    >
      <div class="type-sandbox__wrapper--left">
        <div class="toggles">
          <div class="toggles__toggle">
            <h5
              class="toggles__toggle--title"
              :class="isTextWhite && 'orange-bg'"
            >
              {{ data.weight.title }}
            </h5>
            <select
              class="dropdown"
              v-model="selectedWeight"
              :class="isTextWhite && 'orange-bg white-border white-down-arrow'"
            >
              <option
                v-for="(option, i) in data.weight.options"
                :key="`option_${i}`"
                :value="option"
              >
                {{ option.text }}
              </option>
            </select>
          </div>
          <div class="toggles__toggle">
            <h5
              class="toggles__toggle--title"
              :class="isTextWhite && 'orange-bg'"
            >
              {{ data.italic.title }}
            </h5>
            <div
              class="switch"
              @click="isItalic = !isItalic"
              :class="isTextWhite && 'orange-bg white-border'"
            >
              <div
                class="switch__indicator"
                :class="isTextWhite && 'white-bg'"
                :style="`float: ${isItalic ? 'right' : 'left'}`"
              ></div>
            </div>
          </div>
          <div class="toggles__toggle">
            <h5
              class="toggles__toggle--title"
              :class="isTextWhite && 'orange-bg'"
            >
              {{ data.uppercase.title }}
            </h5>
            <div
              class="switch"
              @click="isUppercase = !isUppercase"
              :class="isTextWhite && 'orange-bg white-border'"
            >
              <div
                class="switch__indicator"
                :class="isTextWhite && 'white-bg'"
                :style="`float: ${isUppercase ? 'right' : 'left'}`"
              ></div>
            </div>
          </div>
          <div class="toggles__toggle">
            <h5
              class="toggles__toggle--title"
              :class="isTextWhite && 'orange-bg'"
            >
              {{ data.colour.title }}
            </h5>
            <div
              class="radio toggles__toggle--radio"
              :class="isTextWhite && 'orange-bg white-border '"
            >
              <div
                v-for="(colour, i) in data.colour.options"
                :key="`colour_${i}`"
                :class="[colour, isTextWhite && 'white-border']"
                class="radio__indicator"
                :style="`float: ${isUppercase ? 'right' : 'left'}`"
                @click="textColour = colour"
              >
                <div
                  :class="`${textColour === 'charcoal' ? 'white' : 'charcoal'}`"
                  class="radio__indicator--chosen"
                  v-if="textColour === colour"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div class="example">
          <h1
            :class="`${textColour}-text `"
            :style="`font-family: ${selectedWeight.value}; font-style: ${
              isItalic ? 'italic' : 'normal'
            }; text-transform: ${isUppercase ? 'uppercase' : 'none'}`"
          >
            {{ selectedWeight.food }}
          </h1>
        </div>
      </div>
      <div
        class="type-sandbox__wrapper--right"
        :class="isTextWhite && 'white-border-left'"
      >
        <p :class="isTextWhite && 'orange-bg'">{{ selectedWeight.intro }}</p>
        <ul class="rules">
          <li v-for="(rule, i) in selectedWeight.rules" :key="`rule_${i}`">
            {{ rule }}
          </li>
        </ul>
        <ul class="instructions">
          <li
            v-for="(instruction, i) in selectedWeight.instructions"
            :key="`instruction_${i}`"
          >
            <p :class="isTextWhite && 'orange-bg'">{{ instruction.title }}</p>
            <p :class="isTextWhite && 'orange-bg'">{{ instruction.text }}</p>
            <p :class="isTextWhite && 'orange-bg'">{{ instruction.heading }}</p>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TypeSandbox',
  props: {
    data: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  data() {
    return {
      selectedWeight: {
        text: 'JET Sans Regular',
        value: `'JETSans-Regular', sans-serif`,
        food: 'Mezze Platter',
        intro: 'Usually used for body copy',
        rules: [
          'Leading 105% - 115%',
          'Tracking 0 to -5',
          'Optical kerning',
          'Sentence case only',
          'Italic available',
        ],
        instructions: [
          {
            title: 'White or light background:',
            text: 'Text under 18pt (24px) should be Charcoal',
          },
          {
            title: 'On an orange background:',
            text: 'Text should be white, and keep size over 10pt (14px)',
          },
        ],
      },
      isItalic: false,
      isUppercase: false,
      textColour: 'orange',
    }
  },
  computed: {
    isTextWhite() {
      return this.textColour === 'white'
    },
  },
}
</script>

<style lang="scss">
$desktop: 1024px;
$tablet: 768px;
$mobile: 600px;

.type-sandbox {
  background-color: var(--color-white-1);
  border: 2px solid var(--color-charcoal-1);
  border-radius: 30px;
  padding: 5px;
  z-index: 1;
  position: relative;
  &__wrapper {
    background-color: var(--color-white-1);
    border: 2px solid var(--color-charcoal-1);
    border-radius: 30px;
    padding: 20px;
    display: flex;
    align-items: center;
    @media (max-width: $tablet) {
      flex-direction: column;
    }
    &--left {
      width: 80%;
      @media (max-width: $tablet) {
        width: 100%;
      }
      .toggles {
        display: flex;
        text-align: center;
        @media (max-width: $tablet) {
          flex-direction: column;
        }
        &__toggle {
          width: 25%;
          @media (max-width: $tablet) {
            width: 100%;
          }
          &--radio {
            width: 80px;
          }
        }
      }
      .example {
        text-align: center;
        h1 {
          font-size: 200px;
          margin: 100px 0;
          line-height: 180px;
          @media (max-width: $tablet) {
            font-size: 70px;
            margin: 50px 0;
            line-height: 70px;
          }
        }
        .orange-text {
          color: var(--color-orange-1);
        }
        .white-text {
          color: var(--color-white-1);
        }
        .charcoal-text {
          color: var(--color-charcoal-1);
        }
      }
    }
    &--right {
      width: 20%;
      border-left: 2px solid var(--color-charcoal-1);
      padding: 20px;
      @media (max-width: $tablet) {
        border-left: 0 solid var(--color-charcoal-1);
        border-top: 2px solid var(--color-charcoal-1);
        width: 100%;
      }
      .instructions {
        list-style: none;
        padding: 0;
      }
    }
  }
}
.orange-bg {
  background-color: var(--color-orange-1);
  color: var(--color-white-1);
}
.white-border {
  border: 2px solid var(--color-white-1);
}
.white-border-left {
  border-left: 2px solid var(--color-white-1);
}
.white-down-arrow {
  background-image: url('../assets/images/white-down-arrow.svg');
}
.white-bg {
  background-color: var(--color-white-1);
}
</style>